import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ProfilePage() {
  const [username, setUsername] = useState('');
  const [userInfo, setUserInfo] = useState({
    name: 'أحمد محمد السعيد',
    email: 'ahmed.saeed@company.com',
    phone: '+966501234567',
    company: 'شركة الرياض للتجارة',
    address: 'شارع الملك فهد، الرياض 12345',
    joinDate: '2023-06-15'
  });
  const navigate = useNavigate();

  useEffect(() => {
    const storedUsername = localStorage.getItem('username');
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('username');
    navigate('/login');
  };

  const profileSections = [
    {
      title: 'المعلومات الشخصية',
      items: [
        { label: 'الاسم الكامل', value: userInfo.name, icon: 'ri-user-line' },
        { label: 'البريد الإلكتروني', value: userInfo.email, icon: 'ri-mail-line' },
        { label: 'رقم الهاتف', value: userInfo.phone, icon: 'ri-phone-line' }
      ]
    },
    {
      title: 'معلومات الشركة',
      items: [
        { label: 'اسم الشركة', value: userInfo.company, icon: 'ri-building-line' },
        { label: 'العنوان', value: userInfo.address, icon: 'ri-map-pin-line' }
      ]
    }
  ];

  const quickActions = [
    {
      title: 'تعديل الملف الشخصي',
      description: 'تحديث المعلومات الشخصية',
      icon: 'ri-edit-line',
      color: 'from-blue-500 to-blue-600',
      action: () => {}
    },
    {
      title: 'تغيير كلمة المرور',
      description: 'تحديث كلمة المرور',
      icon: 'ri-lock-line',
      color: 'from-green-500 to-green-600',
      action: () => {}
    },
    {
      title: 'إعدادات التنبيهات',
      description: 'إدارة الإشعارات',
      icon: 'ri-notification-line',
      color: 'from-purple-500 to-purple-600',
      action: () => navigate('/notifications')
    },
    {
      title: 'مساعدة ودعم',
      description: 'الحصول على المساعدة',
      icon: 'ri-question-line',
      color: 'from-orange-500 to-orange-600',
      action: () => {}
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-500 to-blue-500 text-white p-4 fixed w-full top-0 z-10">
        <div className="flex items-center">
          <button
            onClick={() => navigate('/')}
            className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center ml-3 hover:bg-white/30 transition-colors"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          <div>
            <h1 className="font-bold text-lg">الملف الشخصي</h1>
            <p className="text-sm opacity-90">إدارة معلوماتك الشخصية</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="pt-20 pb-20 px-4">
        {/* Profile Header */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-6">
          <div className="flex items-center">
            <div className="w-20 h-20 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center ml-4">
              <span className="text-white text-2xl font-bold">
                {userInfo.name.split(' ').map(n => n[0]).join('').substring(0, 2)}
              </span>
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-bold text-gray-800 mb-1">{userInfo.name}</h2>
              <p className="text-gray-600 text-sm mb-2">{userInfo.company}</p>
              <div className="flex items-center text-xs text-gray-500">
                <i className="ri-calendar-line ml-1"></i>
                <span>عضو منذ {new Date(userInfo.joinDate).toLocaleDateString('ar-SA')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Profile Information */}
        {profileSections.map((section, index) => (
          <div key={index} className="bg-white rounded-2xl shadow-sm p-6 mb-6">
            <h3 className="font-bold text-gray-800 mb-4 text-right">{section.title}</h3>
            <div className="space-y-4">
              {section.items.map((item, itemIndex) => (
                <div key={itemIndex} className="flex items-center">
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center ml-3">
                    <i className={`${item.icon} text-gray-600`}></i>
                  </div>
                  <div className="flex-1 text-right">
                    <div className="text-sm text-gray-500 mb-1">{item.label}</div>
                    <div className="text-gray-800 font-medium">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* Quick Actions */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-6">
          <h3 className="font-bold text-gray-800 mb-4 text-right">إجراءات سريعة</h3>
          <div className="space-y-3">
            {quickActions.map((action, index) => (
              <button
                key={index}
                onClick={action.action}
                className="w-full bg-gray-50 rounded-xl p-4 hover:bg-gray-100 transition-colors text-right"
              >
                <div className="flex items-center">
                  <div className={`w-12 h-12 bg-gradient-to-r ${action.color} rounded-xl flex items-center justify-center ml-4`}>
                    <i className={`${action.icon} text-white text-xl`}></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="font-bold text-gray-800 mb-1">{action.title}</h4>
                    <p className="text-sm text-gray-600">{action.description}</p>
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-arrow-left-line text-gray-400"></i>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Statistics */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-6">
          <h3 className="font-bold text-gray-800 mb-4 text-right">إحصائياتي</h3>
          <div className="grid grid-cols-2 gap-4">
            <div className="text-center p-4 bg-green-50 rounded-xl">
              <div className="text-2xl font-bold text-green-600 mb-1">15</div>
              <div className="text-sm text-gray-600">إجمالي الطلبات</div>
            </div>
            <div className="text-center p-4 bg-blue-50 rounded-xl">
              <div className="text-2xl font-bold text-blue-600 mb-1">12</div>
              <div className="text-sm text-gray-600">طلبات منجزة</div>
            </div>
            <div className="text-center p-4 bg-orange-50 rounded-xl">
              <div className="text-2xl font-bold text-orange-600 mb-1">2</div>
              <div className="text-sm text-gray-600">قيد التنفيذ</div>
            </div>
            <div className="text-center p-4 bg-purple-50 rounded-xl">
              <div className="text-2xl font-bold text-purple-600 mb-1">1</div>
              <div className="text-sm text-gray-600">طلبات جديدة</div>
            </div>
          </div>
        </div>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="w-full bg-red-500 text-white rounded-2xl p-4 font-bold hover:bg-red-600 transition-colors"
        >
          <div className="flex items-center justify-center">
            <i className="ri-logout-box-line ml-2"></i>
            <span>تسجيل الخروج</span>
          </div>
        </button>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 w-full bg-white border-t border-gray-200 px-4 py-2">
        <div className="grid grid-cols-4 gap-1">
          <button 
            onClick={() => navigate('/')}
            className="flex flex-col items-center py-2 px-1 text-gray-400 hover:text-gray-600"
          >
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-home-line text-lg"></i>
            </div>
            <span className="text-xs">الرئيسية</span>
          </button>
          <button 
            onClick={() => navigate('/requests')}
            className="flex flex-col items-center py-2 px-1 text-gray-400 hover:text-gray-600"
          >
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-file-list-line text-lg"></i>
            </div>
            <span className="text-xs">طلباتي</span>
          </button>
          <button 
            onClick={() => navigate('/notifications')}
            className="flex flex-col items-center py-2 px-1 text-gray-400 hover:text-gray-600"
          >
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-notification-line text-lg"></i>
            </div>
            <span className="text-xs">التنبيهات</span>
          </button>
          <button className="flex flex-col items-center py-2 px-1 text-green-500">
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-user-fill text-lg"></i>
            </div>
            <span className="text-xs">الملف الشخصي</span>
          </button>
        </div>
      </div>
    </div>
  );
}